var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { TrusteeProvider, useTrusteeContext, } from './context';
import { Section, Span } from '@tpr/core';
import { UnderlinedButton } from '../components/button';
import { Preview } from './views/preview';
import { Toolbar } from '../components/toolbar';
import Name from './views/name';
import Type from './views/type/type';
import Address from '../common/views/address/addressPage';
import { Contacts } from './views/contacts';
import RemoveReason from './views/remove/reason/reason';
import { ConfirmRemove } from './views/remove/confirm';
import RemovedBox from '../components/removedBox';
import { cardType, cardTypeName } from '../common/interfaces';
import styles from '../cards.module.scss';
import { AddressComparer } from '@tpr/forms';
import { concatenateStrings, removeFromTabFlowIfMatches } from '../../../utils';
var CardContent = function () {
    var _a = useTrusteeContext(), current = _a.current, i18n = _a.i18n, send = _a.send, addressAPI = _a.addressAPI;
    var trustee = current.context.trustee;
    if (current.matches('preview')) {
        return React.createElement(Preview, null);
    }
    else if (current.matches({ edit: { trustee: 'name' } })) {
        return React.createElement(Name, null);
    }
    else if (current.matches({ edit: { trustee: 'kind' } }) ||
        current.matches({ edit: { trustee: 'save' } })) {
        return React.createElement(Type, null);
    }
    else if (current.matches({ edit: { company: 'address' } }) ||
        current.matches({ edit: { company: 'save' } })) {
        return (React.createElement(Address, { onSubmit: function (values) {
                var comparer = new AddressComparer();
                if (comparer.areEqual(values.initialValue, values)) {
                    send('CANCEL');
                }
                else {
                    send('SAVE', { address: values || {} });
                }
            }, initialValue: trustee.address, addressAPI: addressAPI, cardType: cardType.trustee, cardTypeName: cardTypeName.trustee, sectionTitle: i18n.address.sectionTitle, i18n: i18n.address, onCancelChanges: function () { return send('CANCEL'); } }));
    }
    else if (current.matches({ edit: { contact: 'details' } }) ||
        current.matches({ edit: { contact: 'save' } })) {
        return React.createElement(Contacts, null);
    }
    else if (current.matches({ remove: 'reason' })) {
        return React.createElement(RemoveReason, null);
    }
    else if (current.matches({ remove: 'confirm' })) {
        return React.createElement(ConfirmRemove, null);
    }
    else if (current.matches({ remove: 'deleted' })) {
        return React.createElement(RemovedBox, { type: cardTypeName.trustee });
    }
    else {
        return null;
    }
};
var TrusteeButton = function () {
    var _a = useTrusteeContext(), current = _a.current, send = _a.send, i18n = _a.i18n;
    return (React.createElement(UnderlinedButton, { isOpen: current.matches({ edit: { trustee: 'name' } }) ||
            current.matches({ edit: { trustee: 'kind' } }) ||
            current.matches({ edit: { trustee: 'save' } }) ||
            current.matches({ edit: { company: 'address' } }) ||
            current.matches({ edit: { company: 'save' } }) ||
            current.matches({ edit: { contact: 'details' } }) ||
            current.matches({ edit: { contact: 'save' } }) ||
            current.matches({ remove: 'reason' }) ||
            current.matches({ remove: 'confirm' }), onClick: function () {
            if (current.matches({ edit: { trustee: 'name' } }) ||
                current.matches({ edit: { trustee: 'kind' } }) ||
                current.matches({ edit: { company: 'address' } }) ||
                current.matches({ edit: { contact: 'details' } }) ||
                current.matches({ remove: 'reason' }) ||
                current.matches({ remove: 'confirm' })) {
                send('CANCEL');
            }
            else {
                send('EDIT_TRUSTEE');
            }
        } }, i18n.preview.buttons.one));
};
var RemoveButton = function (_a) {
    var tabIndex = _a.tabIndex;
    var _b = useTrusteeContext(), current = _b.current, send = _b.send, i18n = _b.i18n;
    return (React.createElement(UnderlinedButton, { isOpen: current.matches({ remove: 'reason' }) ||
            current.matches({ remove: 'confirm' }), onClick: function () {
            if (current.matches({ remove: 'reason' }) ||
                current.matches({ remove: 'confirm' })) {
                send('CANCEL');
            }
            else {
                send('REMOVE');
            }
        }, tabIndex: tabIndex }, i18n.preview.buttons.two));
};
var isComplete = function (context) {
    return context.preValidatedData ? true : context.complete;
};
export var TrusteeCard = function (_a) {
    var cfg = _a.cfg, props = __rest(_a, ["cfg"]);
    return (React.createElement(TrusteeProvider, __assign({}, props), function (_a) {
        var current = _a.current, i18n = _a.i18n;
        return (React.createElement(Section, { cfg: cfg, "data-testid": props.testId, className: styles.card, ariaLabel: concatenateStrings([
                current.context.trustee.title,
                current.context.trustee.firstName,
                current.context.trustee.lastName,
                current.context.trustee.trusteeType,
                i18n.preview.buttons.one,
            ]) },
            React.createElement(Toolbar, { complete: isComplete(current.context), buttonLeft: function () { return React.createElement(TrusteeButton, null); }, buttonRight: function () { return (React.createElement(RemoveButton, { tabIndex: removeFromTabFlowIfMatches(current, {
                        edit: { trustee: 'name' },
                    }) })); }, subtitle: function () { return (React.createElement(Span, { cfg: { lineHeight: 3 }, className: styles.styledAsH4 }, concatenateStrings([
                    current.context.trustee.title,
                    current.context.trustee.firstName,
                    current.context.trustee.lastName,
                ]))); }, statusText: isComplete(current.context)
                    ? i18n.preview.statusText.confirmed
                    : i18n.preview.statusText.unconfirmed }),
            React.createElement(CardContent, null)));
    }));
};
//# sourceMappingURL=trustee.js.map